module.exports = __webpack_public_path__ + "img/fssai.de434470.png";